// extracted by mini-css-extract-plugin
export default {"overlay":"SearchOverlay_overlay__8Hl6P","searchWrapper":"SearchOverlay_searchWrapper__f+kiF","close":"SearchOverlay_close__T94tx"};